import { StaticImage } from 'gatsby-plugin-image';
import * as React from 'react';

import { Hero, ImageClipping } from '../components/containers/hero';
import { Panel } from '../components/containers/panel';
import { Section, Style as SectionStyle } from '../components/containers/section';
import { SectionText } from '../components/containers/section-text';
import { Style as ButtonStyle, Type as ButtonType } from '../components/elements/button';
import { TextButton } from '../components/elements/text-button';
import { Site } from '../components/shells/site';
import { Seo } from '../components/utilities/seo';

export default (): React.ReactElement => {
    return (
        <Site>
            <Seo
                title={'Walk & Relax in regio Maastricht'}
            />

            <Hero
                image={<StaticImage src={'../../assets/images/hero-training-1.jpg'} alt={''} />}
                imageClipping={ImageClipping.VerticalBlob}
                pageTitle={'Walk & Relax in regio Maastricht'}
                pageText={'Wil je in groepsverband sporten? Meld je dan aan voor mijn trainingen!'}
            />

            <Section style={SectionStyle.Light}>
                <SectionText>
                    <div className={'grid md:grid-cols-2 gap-12'}>
                        <div className={'text-left'}>
                            <h2 className={'text-2xl font-bold mb-4'}>Wat is Walk &amp; Relax training?</h2>
                            <div className={'prose'}>
                                <p>Deze wekelijkse training is een unieke combinatie van wandelen, yoga, mindfulness en ademhaling. Alles in één les, buiten in de natuur.</p>
                                <p>Je lichaam komt in beweging, je hoofd komt tot rust en je voelt je na afloop opgeladen en in balans.</p>
                            </div>

                            <Panel className={'mt-8'}>
                                <h2 className={'text-2xl font-bold mb-4'}>Doe mee!</h2>
                                <p><strong>Tijd:</strong> zaterdag 9:30 - 10:30<br /><strong>Locatie:</strong> Het Vöske, Berg en Terblijt</p>

                                <h3 className={'font-bold mt-8'}>Kosten</h3>
                                <p>Strippenkaart voor 10 lessen € 85</p>

                                <TextButton
                                    type={ButtonType.Link}
                                    style={ButtonStyle.Primary}
                                    url={`https://wa.me/31641777848?text=${encodeURIComponent(
                                        'Hoi! Ik wil me graag aanmelden voor Walk & Relax op zaterdag'
                                    )}`}
                                    caption={'Aanmelden via WhatsApp'}
                                    callout={false}
                                    className={'mt-8'}
                                />
                            </Panel>
                        </div>
                        <div className={'text-left'}>
                            <h2 className={'text-xl font-bold mb-1'}>Waarom de Walk &amp; Relax training?</h2>
                            <div className={'prose'}>
                                <ul>
                                    <li>Als je behoefte hebt aan meer rust, zonder stil te zitten.</li>
                                    <li>Conditie en kracht wilt opbouwen op een zachte manier.</li>
                                    <li>Beter wilt leren ademen en ontspannen.</li>
                                    <li>Buiten zijn fijn vindt, maar het alleen lastig vindt om te starten.</li>
                                    <li>Een moment in de week zoekt dat écht voor jou is.</li>
                                </ul>
                            </div>
                            <h2 className={'text-xl font-bold mt-8 mb-1'}>Voor wie zijn de Walk &amp; Relax trainingen?</h2>
                            <div className={'prose'}>
                                <p>De Walk & Relax trainingen zijn er voor jou als je voelt dat het tijd is om beter voor jezelf te zorgen. Als je uit je hoofd en lijf wilt komen. En als je op zoek bent naar een manier om conditie op te bouwen, kracht én innerlijke rust op te bouwen zonder prestatiedruk.</p>
                            </div>
                        </div>
                    </div>
                </SectionText>
            </Section>
        </Site>
    );
};
